"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3ControllerBase = void 0;
const AppControllerBase_1 = require("./AppControllerBase");
const gs = require("@ivanlog/gs");
const BiMath_1 = require("../libs/BiMath");
class Web3ControllerBase extends AppControllerBase_1.AppControllerBase {
    constructor(app, chainId, rpc) {
        super(app);
        this._constracts = [];
        this._chainId = chainId;
        this._rpc = rpc;
        this._onChangeAccountToken = new gs.EventAsyncGSToken();
        this._onChangeAccount = new gs.EventAsyncGS(this._onChangeAccountToken);
    }
    get onChangeAccount() { return this._onChangeAccount; }
    get isConnected() { return this._web3 != undefined; }
    get chainId() { return this._chainId; }
    get web3() { return this._web3; }
    get account() { return this._account; }
    startAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initWeb3Async();
        });
    }
    getAccountAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._account)
                return this._account;
            const result = this.refreshAccountAsync();
            return result;
        });
    }
    getChainIdAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const eth = globalThis.ethereum;
            if (!eth)
                return this.chainId;
            const currentChainId = yield eth.request({ method: 'eth_chainId' });
            return currentChainId;
        });
    }
    refreshAccountAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const eth = globalThis.ethereum;
            //chain validation
            const currentChainId = yield eth.request({ method: 'eth_chainId' });
            if (currentChainId != this.chainId) {
                try {
                    yield eth.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: this.chainId }]
                    });
                }
                catch (switchError) {
                    this._app.gui.dialogOkShowAsync("Wrong blockchain selected. Change blockchain and refresh page.");
                    return yield this._selectAccountAsync(undefined, new globalThis.Web3(new globalThis.Web3.providers.HttpProvider(this._rpc)));
                }
            }
            else {
                const accounts = yield eth.request({ method: 'eth_requestAccounts' });
                if (accounts.length == 0)
                    return;
                return yield this._selectAccountAsync(accounts[0], new globalThis.Web3(eth));
            }
        });
    }
    tryConnectAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const modalWalletError = this._app.gui.dialogOkCreate("It looks like your browser doesn't have a wallet installed. Please use a browser with a functioning MetaMask or Rabby extension", "Information");
            const modalAgreement = this._app.gui.dialogOkCreate("", "Information");
            modalAgreement.ctrls.lText.html = "Please confirm that you have read and agree to the <a href=\"https://up.docs.plusx.app/?folder=ValidatorX&article=Terms%20of%20Use\" target='_blank'>Terms of Use</a> by clicking the button below.";
            const result = yield modalAgreement.showAndWaitAsync();
            if (!result)
                return false;
            try {
                const account = yield this.getAccountAsync();
                if (!account) {
                    if (account != false)
                        modalWalletError.show();
                    return false;
                }
                return true;
            }
            catch (error) {
                modalWalletError.show();
                console.error(error);
                //throw error;
                return false;
            }
        });
    }
    addContract(contract) { this._constracts.push(contract); }
    addContracts(contracts) { gs.array.addRange(this._constracts, contracts); }
    _loadAccountAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const eth = globalThis.ethereum;
            //chain validation
            const currentChainId = yield eth.request({ method: 'eth_chainId' });
            if (currentChainId != this._chainId)
                return;
            const accounts = yield eth.request({ method: 'eth_accounts' });
            if (accounts.length == 0)
                return;
            return yield this.refreshAccountAsync();
        });
    }
    _selectAccountAsync(account, web3) {
        return __awaiter(this, void 0, void 0, function* () {
            this._account = account;
            this._web3 = web3;
            yield this._handleSelectAccountAsync(account, web3);
            yield this._onChangeAccountToken.invoke();
            if (!this._account)
                return false;
            return this._account;
        });
    }
    _handleSelectAccountAsync(account, web3) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const c of this._constracts)
                c.updateWeb3(web3);
        });
    }
    ;
    getBalanceEth() {
        return __awaiter(this, void 0, void 0, function* () {
            const account = this.account;
            if (!account)
                return;
            try {
                const balance = yield this._web3.eth.getBalance(account);
                return this._web3.utils.fromWei(balance, 'ether');
            }
            catch (error) { }
            return;
        });
    }
    addTokenToWalletAsync(address, symbol, decimal) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!globalThis.ethereum)
                return false;
            const eth = globalThis.ethereum;
            try {
                // 'wasAdded' is a boolean. Like any RPC method, an error can be thrown.
                const wasAdded = yield eth.request({
                    method: 'wallet_watchAsset',
                    params: {
                        type: 'ERC20',
                        options: {
                            address: address,
                            symbol: symbol,
                            decimals: decimal, // The number of decimals in the token.
                            //image: tokenImage, // A string URL of the token logo.
                        },
                    },
                });
                return wasAdded;
            }
            catch (error) {
                console.log(error);
                return false;
            }
        });
    }
    initWeb3Async() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._web3 = new globalThis.Web3(new globalThis.Web3.providers.HttpProvider(this._rpc));
                BiMath_1.BiMath.Init(this._web3);
                if (window.ethereum) {
                    //Отлавливаем изменение аккаунта и обновляем аккаунт
                    window.ethereum.on('accountsChanged', (accounts) => __awaiter(this, void 0, void 0, function* () {
                        yield this.refreshAccountAsync();
                    }));
                    //Отлавливаем изменение чейна и обновляем аккаунт
                    window.ethereum.on('chainChanged', (accounts) => __awaiter(this, void 0, void 0, function* () {
                        yield this.refreshAccountAsync();
                    }));
                    yield this._loadAccountAsync();
                }
            }
            catch (e) {
                this._app.gui.dialogOkShowAsync(e);
            }
        });
    }
}
exports.Web3ControllerBase = Web3ControllerBase;
//# sourceMappingURL=Web3ControllerBase.js.map